import React from 'react'

import styled, { keyframes, css } from 'styled-components'

const Loader = ({ variant = 'primary', bgColor1 = '#f06c5f', bgColor2 = '#6be2ce', bgColor3 = '#0083e0' }) => {
  switch (variant) {
    case 'primary': {
      return (
        <Wrapper>
          <Background />
          <ContainerLoader>
            <Hexa spin='0' width='70px' height='80px' color={bgColor1} margin='0 0 0 80px' />
            <Hexa spin='1' width='70px' height='80px' color={bgColor2} margin='-65px 0 0 40px' />
            <Hexa spin='2' width='70px' height='80px' color={bgColor3} margin='0 0 0 0' />
          </ContainerLoader>
        </Wrapper>
      )
    }
    case 'secondary': {
      return (
        <ContainerLoader>
          <Hexa spin='0' width='20px' height='22px' color={bgColor1} margin='0 0 0 80px' />
          <Hexa spin='1' width='20px' height='22px' color={bgColor2} margin='-18px 0 0 70px' />
          <Hexa spin='2' width='20px' height='22px' color={bgColor3} margin='0 0 0 59px' />
        </ContainerLoader>
      )
    }
    case 'SwipeableViews': {
      return (
        <Wrapper SwipeableViews>
          <Background SwipeableViews />
          <ContainerLoader>
            <Hexa spin='0' width='70px' height='80px' color={bgColor1} margin='0 0 0 80px' />
            <Hexa spin='1' width='70px' height='80px' color={bgColor2} margin='-65px 0 0 40px' />
            <Hexa spin='2' width='70px' height='80px' color={bgColor3} margin='0 0 0 0' />
          </ContainerLoader>
        </Wrapper>
      )
    }
    default: {
      return (
        <Wrapper>
          <Background />
          <ContainerLoader>
            <Hexa spin='0' width='70px' height='80px' color={bgColor1} margin='0 0 0 80px' />
            <Hexa spin='1' width='70px' height='80px' color={bgColor2} margin='-65px 0 0 40px' />
            <Hexa spin='2' width='70px' height='80px' color={bgColor3} margin='0 0 0 0' />
          </ContainerLoader>
        </Wrapper>
      )
    }
  }
}

const Wrapper = styled.div`
  position: absolute;
  min-width: 100%;
  height: 100%;
  top: 0;
  ${(props) =>
    !props.SwipeableViews &&
    css`
      left: 0;
    `}

  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 997;
`
const Background = styled.div`
  position: absolute;
  min-width: 100%;
  ${(props) =>
    !props.SwipeableViews &&
    css`
      height: 100%;
    `}
  top: 0;
  left: 0;
  background-color: #d4d2d2;
  opacity: 0.3;
  z-index: 998;
`

const ContainerLoader = styled.div`
  position: relative;
  margin-left: -150px;
  z-index: 1800;
`

const animations = [
  keyframes`
    0%, 10% {
      transform: translateX(0px) translateY(0px) rotate(0deg);
    }
    50% {
      transform: translateX(50%) translateY(50%) rotate(360deg);
    }
    90%, 100% {
      transform: translateX(0px) translateY(0px) rotate(720deg);
    }
  `,
  keyframes`
    0%, 10% {
      transform: translateX(0px) translateY(0px) rotate(0deg);
    }
    50% {
      transform: translateX(0px) translateY(-36%) rotate(360deg);
    }
    90%, 100% {
      transform: translateX(0px) translateY(0px) rotate(720deg);
    }
  `,
  keyframes`
    0%, 10% {
      transform: translateX(0px) translateY(0px) rotate(0deg);
    }
    50% {
      transform: translateX(-50%) translateY(50%) rotate(360deg);
    }
    90%, 100% {
      transform: translateX(0px) translateY(0px) rotate(720deg);
    }
  `,
]

const Hexa = styled.div`
  position: absolute;
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  margin: ${({ margin }) => margin};
  background-color: ${({ color }) => color};
  animation: ${({ spin }) => animations[spin]} 2.5s ease-in-out infinite;
`

export default Loader
